import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import CreditCard from '@icons/paymentMethod/CreditCard';
import { useTranslation } from 'react-i18next';

function PrepaidCardChargeMethod() {
    const { t } = useTranslation('prepaidCard');
    return (
        <Container fullWidth
            spacing={24}>
            <Text size='2xl'
                fontWeight='bold'
                color={colors.gray7}>
                {t('components.chargeMethod.title')}
            </Text>
            {/*
            <Column align='center' spacing={8}>
                <CreditCard size={52} color={colors.primary}/>
                <Text fontWeight='bold'>{t('components.chargeMethod.creditCard')}</Text>
            </Column>
            */}
        </Container>
    );
}

const Container = styled(Column)`
    padding: 0 20px 40px;
`;

export default PrepaidCardChargeMethod;
